import { IconProduct3DTour16, IconProductDateTime16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './PhotoFeatureIcons.css';
import { IPhotoFeatureIcon } from '../../../../../../../common/repositories/dailyrent/entities/photo_feature_icon/PhotoFeatureIcon';
import { PhotoFeatureIcon } from '../PhotoFeatureIcon';

export interface IPhotoFeatureIcons {
  photoFeatureIcons: IPhotoFeatureIcon[] | undefined | null;
}

const icons: { [type: string]: React.ReactNode } = {
  has3dTour: <IconProduct3DTour16 color="white_100" />,
  hasFlatTourBooking: <IconProductDateTime16 color="white_100" />,
};

const PhotoFeatureIconsComponent: React.FC<IPhotoFeatureIcons> = ({ photoFeatureIcons }) => {
  if (!photoFeatureIcons || photoFeatureIcons.length === 0) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {photoFeatureIcons.map(photoFeatureIcon => {
        const type = photoFeatureIcon.type;
        const icon = icons[type];

        return <PhotoFeatureIcon key={type} icon={icon} className={styles['icon']} />;
      })}
    </div>
  );
};

export const PhotoFeatureIcons = React.memo(PhotoFeatureIconsComponent);
